module.exports = __webpack_public_path__ + "static/media/x-icon.b0223624.svg";